<ng-container *adaptLoadingUntilFirstEmit="let outstandingSurveyResponses of outstandingSurveyResponses$">
    @if (outstandingSurveyResponses!.length > 0) {
        <adapt-universal-dashboard-element name="Outstanding Survey{{ outstandingSurveyResponses!.length > 1 ? 's' : '' }}">
            <div class="d-flex flex-column gap-3">
                @for (outstandingSurveyResponse of outstandingSurveyResponses; track outstandingSurveyResponse) {
                    <div>
                        <h4>
                            {{ getSurveyHeader(outstandingSurveyResponse.survey) }}
                        </h4>
                        <adapt-personal-ongoing-survey
                                                       [outstandingSurveyResponse]="outstandingSurveyResponse"></adapt-personal-ongoing-survey>
                    </div>
                }
            </div>
        </adapt-universal-dashboard-element>
    }
</ng-container>
